import {ruleServerUrl} from 'configs/rule-server'
import * as Immutable from 'immutable'
import campaignService from '../../../services/campaigns-service.js'
// ------------------------------------
// Constants
// ------------------------------------
export const SELECT_DAY = 'SELECT_DAY'
export const SELECT_HIERARCHY = 'SELECT_HIERARCHY'
export const GENDER_OPTIONS = 'GENDER_OPTIONS'
export const UPDATE_FILTER_VALUES = 'UPDATE_FILTER_VALUES'
export const LOAD_STORE_NAMES = 'LOAD_STORE_NAMES'

// ------------------------------------
// Actions
// ------------------------------------

// ------------------------------------
// Action Handlers
// ------------------------------------

function getDistictGenderValues() {
  return {
    'size': 0,
    'aggs': {
      'distinct_gender_values': {
        'terms': {
          'field': 'gender',
          'size': 10
        }
      }
    }
  }
}


export function setUpdatedFilterValues(filter) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_FILTER_VALUES,
      filter: Immutable.fromJS(filter)
    })
  }
}

export function loadStoreNameOptions() {
  return (dispatch, getState) => {
    return campaignService.getStores().then((stores) => {
      let options = stores.map(store => {
        return {label: store.store, value: store.store}
      });
      dispatch({
        type: LOAD_STORE_NAMES,
        storeOptions: options
      })
    })
  }
}

// ------------------------------------
// Reducer
// ------------------------------------

let defaultState = Immutable.fromJS([])

export function genderOptionsReducer(state = defaultState, action) {
  switch (action.type) {
    case GENDER_OPTIONS: {
      return action.genderOptions
    }
    default:
      return state
  }
}

export function filterValuesReducer(state = Immutable.fromJS({}), action) {
  switch (action.type) {
    case UPDATE_FILTER_VALUES: {
      return action.filter
    }
    default:
      return state
  }
}

export function loadStoreOptionsReducer(state = [], action) {
  switch (action.type) {
    case LOAD_STORE_NAMES: {
      return action.storeOptions
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/routes/Home/modules/home.js